import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { lessonTaskApi, tLessonTask, tSharedAppState } from 'common/modules/ReactShared';
import { isPreviewingLesson } from '../../lesson/preview';

type tLessonTaskData = tLessonTask | null;
const initialLessonTaskState: tLessonTaskData = null;

const fetchLessonTask = createAsyncThunk<
  tLessonTask | null,
  {
    lessonId: number;
    taskId: tLessonTask['id'];
  },
  { state: tSharedAppState }
>('lessonTask/fetchLessonTask_request', async ({ taskId, lessonId }, { getState }) => {
  const { task } = await lessonTaskApi.fetchLessonTask(
    lessonId,
    taskId,
    isPreviewingLesson(getState(), lessonId)
  );
  return task;
});

const lessonTaskSlice = createSlice({
  name: 'lessonTask',
  initialState: initialLessonTaskState as tLessonTaskData,
  reducers: {
    drop: () => {
      return initialLessonTaskState;
    },
    /** Puts a task that was loaded elsewhere (e.g. with a batch) in the store. */
    set: (_, action: PayloadAction<tLessonTaskData>) => {
      return action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchLessonTask.fulfilled, (_, action) => {
      return action.payload;
    });
  }
});

const { reducer, actions } = lessonTaskSlice;
export const dataActions = { ...actions, fetchLessonTask };

export default reducer;
export type { tLessonTaskData };
